// extracted by mini-css-extract-plugin
export default {"deviceModels":"DeviceModels_deviceModels__+n6m+"};